import {Component, Host, h, Prop} from '@stencil/core';

@Component({
  tag: 'nest-panel',
  styleUrl: 'nest-panel.scss',
  shadow: true,
})
export class NestPanel {
  @Prop() heading: string;

  @Prop() description: string;

  @Prop() secondary: boolean;

  @Prop() fit: boolean;

  @Prop({ mutable: true, reflect: true }) closed = false;

  render() {
    const {heading, description, closed, secondary, fit} = this
    return (
      <Host hidden={closed}>
        <div class={`nest-panel ${!secondary ? 'bg-gray-100' : 'bg-white'}`}>
          {heading && (
            <div class="flex items-center justify-between px-6 py-5 border-b bg-white">
              <slot name='panel-start-actions'/>
              <div>
                <div class='font-medium nest-panel-header__title'>{heading}</div>
                <div class='nest-panel-header__description'>{description}</div>
              </div>
              <slot name='panel-actions'/>
            </div>
          )}

          <div class={{
            'nest-panel__content overflow-y-auto': true,
            'px-6': !fit && secondary
          }}>
            <slot></slot>
          </div>
        </div>
      </Host>
    )
  }

}
